import { DEFAULT_TIMEZONE } from '@/lib/constants/timezone-constants';

let cachedTimezone = DEFAULT_TIMEZONE;

export function getAccountTimezone(): string {
  return cachedTimezone;
}

export function setAccountTimezoneCache(timezone: string): void {
  cachedTimezone = timezone;
}
